var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;

var RequestFitting = React.createClass({

  showFittingReqForm: function() {
    this.props.showFittingReqForm();
  },

  rawMarkup: function() {
    return { __html: CMS.misc.requestFitting.replace(/____/g, "<br/>") };
  },

  render: function() {
  	return <div className="col-sm-6 col-md-4 footer-col">
  	    <h5>Request a Fitting</h5>
        <div dangerouslySetInnerHTML={this.rawMarkup()} />
  	    <a id="footer-request" onClick={this.showFittingReqForm} role="button">REQUEST&nbsp;&nbsp;&gt;</a>
  	  </div>
  }
});

var StayInTouch = React.createClass({

  thanksMsg: CMS.misc.thanks_msg_join_newsletter.replace(/____/g, "<br/>"),

  componentDidMount: function() {
    var submitHandler = function(){
            
            jQuery.post("/contact",
                { form_type: "customer",
                  utf8: "✓",
                  "contact[tags]": "prospect,newsletter",
                  "contact[email]": jQuery(this.refs.email.getDOMNode()).val() },
                function(result) {
                  jQuery(this.refs.email.getDOMNode()).val('');
                  this.props.showThankYou(this.thanksMsg);
                }.bind(this))          
            .error(function(e) {
              jQuery(this.refs.email.getDOMNode()).val('');
              this.props.showThankYou(this.thanksMsg);
            }.bind(this));
        }.bind(this);
        
    jQuery('#newsletter-signup').validate({
        rules: {
            email: {
              required: true,
              email: true
            }
        },
        errorPlacement: function(error, element){
            error.appendTo('#newsletter-signup');
        },
        submitHandler: submitHandler
    })
  },

  handleClick: function(e) {
    e.preventDefault();
    jQuery('#newsletter-signup').submit();
  },

  rawMarkup: function() {
    return { __html: CMS.misc.stayInTouch.replace(/____/g, "<br/>") };
  },

  render: function() {
  	return <div className="col-sm-6 col-md-4 footer-col">
  	    <h5>Sign up to stay connected</h5>
  	    <div dangerouslySetInnerHTML={this.rawMarkup()} />
            <div>
            <form id="newsletter-signup">
                <input type="text" name="email" placeholder="YOUR EMAIL*" ref="email"></input>
                <a href="#" id="footer-join" onClick={this.handleClick}>
                    JOIN&nbsp;&nbsp;&nbsp;&gt;
                </a>
                    
            </form>
            </div>
  	  </div>
  }
});

var Social = React.createClass({
  render: function() {
  	return <div className="col-xs-6 col-md-2 footer-col">
            <ul>
              <li><a href={SiteLinks.facebook_link} target="_blank">FACEBOOK</a></li>
              <li><a href={SiteLinks.instagram_link} target="_blank">INSTAGRAM</a></li>
              <li><a href={SiteLinks.twitter_link} target="_blank">TWITTER</a></li>
              <li><a href={SiteLinks.pinterest_link} target="_blank">PINTEREST</a></li>
            </ul>
  	    </div>
  }
});

var Misc = React.createClass({
    render: function(){
        return <div className="col-xs-6 col-md-2 footer-col">
            <ul>
              <li><Link to="/pages/help">Need Help?</Link></li>
              <li><Link to="/pages/shipping-returns">Shipping & Returns</Link></li>
              <li><Link to="/pages/gift-card">Gift Cards</Link></li>
              <li><Link to="/pages/careers">Careers</Link></li>
              <li><Link to="/pages/privacy-policy">Privacy Policy</Link></li>
            </ul>
        </div>
    }
});

module.exports = React.createClass({

  render: function() {
    var year = new Date().getFullYear();
  	return <footer>
        <div className="container">
            <div className="row">
              <RequestFitting ref="reqFitting" showFittingReqForm={this.props.showFittingReqForm} />
              <StayInTouch ref="stayInTouch" showThankYou={this.props.showThankYou}/>
              <div className="clearfix visible-sm-block"></div>
              <Social/>
              <Misc/>
            </div>
            <div id="copyright"><small>Copyright &copy; 2005 - {year} Ingledew's Shoes. All rights reserved.</small></div>
        </div>
        </footer>
  }
});